import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/lib/init-sentry";
import { trackActivity } from "@/lib/integrations/activity-events";
import { installChunkReloadHandler } from "@/lib/utils/chunk-reload";
import { App } from "@/app/app";
import "@fontsource-variable/dm-sans";
import "@fontsource-variable/plus-jakarta-sans";
import "@/styles/globals.css";

installChunkReloadHandler();
trackActivity("app.launch");

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
